/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Empty from "antd/lib/empty";
import { retrieveApi } from "api/retrive";
import { Mission } from "api/retrive/type";
import Loading from "components/Common/Loading";
import { useAppSelector } from "hooks/app-hook";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ChallengeWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
  font-family: Arial, sans-serif;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 24px;
`;

const MissionCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
`;

const MissionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 8px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

// const ProgressBar = styled.div`
//   background: #eee;
//   border-radius: 8px;
//   height: 10px;
//   overflow: hidden;
// `;

// const NoDataMessage = styled.div`
//   text-align: center;
//   padding: 40px;
//   color: #718096;
//   font-size: 16px;
// `;

// interface ProgressProps {
//   percent: number;
// }

// const Progress = styled.div<ProgressProps>`
//   background: #4a5568;
//   height: 100%;
//   width: ${({ percent }) => percent}%;
//   transition: width 0.4s ease;
// `;

interface StatusProps {
  status: string;
}

const Status = styled.span<StatusProps>`
  font-size: 14px;
  font-weight: bold;
  color: ${({ status }) =>
    status === "Completed"
      ? "#38a169"
      : status === "Failed"
      ? "#e53e3e"
      : status === "Entitlement"
      ? "#4299e1"
      : "#718096"};
`;

const Challenge = () => {
  const [missions, setMissions] = useState<Mission[]>([]);
  const [loading, setLoading] = useState(false);
  const username = useAppSelector((state) => state.auth.username);
  const { t } = useTranslation("challenge");

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        setLoading(true);
        const response = await retrieveApi.getPromotionChanllenge(username);
        if (response.data) {
          setMissions(response.data);
        }
      } catch (error) {
        console.error("Error fetching challenges:", error);
      } finally {
        setLoading(false);
      }
    };

    if (username) {
      fetchChallenges();
    }
  }, [username]);

  return (
    <ChallengeWrapper>
      <Title>{t("title")}</Title>
      {loading ? (
        <Loading height={500} width={"100%"} center />
      ) : missions.length === 0 ? (
        <MissionCard>
          <Empty description={t("message:Empty")} />
        </MissionCard>
      ) : (
        missions.map((m, idx) => {
          return (
            <MissionCard key={idx}>
              <MissionHeader>
                <span>{m.promotion_name}</span>
                <span>{m.reward_percentage}</span>
              </MissionHeader>
              <InfoRow>
                <span>
                  {t("archiveAmount")}: {m.achieve_amount}
                </span>
              </InfoRow>
              <InfoRow>
                <span>
                  {t("currentAmount")}: {m.current_amount}
                </span>
              </InfoRow>
              <div
                css={css`
                  margin-top: 8px;
                  text-align: left;
                `}
              >
                <Status status={m.status_pro}>{m.status_pro}</Status>
              </div>
            </MissionCard>
          );
        })
      )}
    </ChallengeWrapper>
  );
};

export default Challenge;
